var render, staticRenderFns
import script from "./Dialog.vue?vue&type=script&lang=tsx"
export * from "./Dialog.vue?vue&type=script&lang=tsx"
import style0 from "./Dialog.vue?vue&type=style&index=0&id=d00b4eb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d00b4eb0",
  null
  
)

export default component.exports